import { useState } from "react";

/**
 * Only updates the state if it's passed a non-nullish value,
 * otherwise persists the last one.
 *
 * Tracked in state rather than a ref so the value can be read during render
 * (React Compiler disallows reading `ref.current` while rendering).
 *
 * `passed` must be referentially stable while unchanged — the guard below is an
 * identity check, so a freshly allocated value on every render would set state
 * on every render and loop. Pass props/context/query values, not inline
 * literals or `?? {}` fallbacks.
 */
const useLastNonNullishValue = <T>(passed: T | null = null): T | null => {
  const [last, setLast] = useState<T | null>(passed);

  if (passed != null && passed !== last) {
    setLast(passed);
  }

  return passed ?? last;
};

export default useLastNonNullishValue;
